import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  additionDetails,
  maskGlusrFields,
  displayVerified,
  errorLogHandling,
  glusr_details,
  lstStatus_updation,
  updateAdditionalDataGST,
  updateGlusrDetails,
} from "../services/userservice";
import { decryptPII } from "../utils/encryption/aesEncryption";
import TopCategories from "./TopCategories";
import { gaEvent } from "../utils/GoogleAnalytics/gatracking";
import EmployeeContext from "../utils/EmpDetails/EmployeeProvider";
import { PiLightbulbFilamentThin } from "react-icons/pi";
import {
  apiAssignToCompany,
  clickToCall,
  countriesInfo,
  createNewSTSID,
  ctcActivity,
  getSTSID,
  getServiceDetailsCached,
  hotlead_proc,
  insertclicktocall,
  insertstsdata,
  unblockSpamUser,
  updateSTS,
  update_click_to_call_stsid,
} from "../services/merpservices";
import { Alert } from "../utils/Alert";
import { data } from "./bizdata";
import Popup from "./Popup";
import CustomerEngagement from "../components/customerEngagement/CustomerEngagement";
import PostBuyLeadPopup from "./PostBuyLeadPopup";
import PopupComponent from "./Phonic";
import { Tooltip } from "react-tooltip";
import HotLeadMessage from "./HotLeadMessage";
import ConnectSeller from "./ConnectSeller";
import FloatLabelInput from "../components/FloatLabelInput/FloatLabelInput";
import { EmailValidation } from "./EmailValidation";
import { blackList } from "../services/dbservices";
import BuyerEngagement from "../components/customerEngagement/BuyerEngagement";
import RadioButton from "../components/RadioButton/RadioButton";
import { useGlobalContext } from "../SearchBar/SearchBar";
import { maskMobileNumber } from '../utils/Misc/maskMobileNumber';
import { useGlobalAppContext } from "../context/Context";
import EnterpriseSolutionsPopup from "../SearchBar/EnterpriseSolutionsPopup";
import HotleadCreationForPaidSeller from "../components/HotleadCreationForPaidCustomer/HotleadCreationForPaidSeller";
import DescriptionDropdown from "./DescriptionDropdown";
import getCookie from "../utils/GetCookie/getCookie";
import getIP from "../utils/EmpDetails/getIP";
import { DwhContextProvider } from "../context/DwhContextProvider";


const _countriesInfoPromise = {};

// ─────────────────────────────────────────────────────────────────────────────
// TabEngagement — isolated component, only re-renders when selectedTab changes
// ─────────────────────────────────────────────────────────────────────────────
const TabEngagement = React.memo(
  ({ selectedTab, glid, empid, ak, companyName, setTopProductsList }) => {
    if (selectedTab === "9") return null;

    if (selectedTab === "7") {
      if (
        window.location.pathname === "/api/html" ||
        window.location.pathname === "/Controllers/inBoundCenter.php"
      ) {
        return (
          <BuyerEngagement glid={glid} empid={empid} ak={ak} setTopProductsList={setTopProductsList} />
        );
      }
      return (
        <div className="buyer-insight-note">
          <PiLightbulbFilamentThin className="buyer-icon" />
          <br />
          <span>
            Buyer Insights <br /> Coming Soon
          </span>
        </div>
      );
    }

    return (
      <CustomerEngagement
        empid={empid}
        ak={ak}
        glid={glid}
        companyname={companyName}
        setTopProductsList={setTopProductsList}
      />
    );
  }
);

const TabButtons = React.memo(
  ({
    selectedTab,
    isUpdateDisabled,
    onUpdate,
    glid,
    empid,
    ak,
    descHiddenValue,
    handleDisableBtn,
    sts_id,
    hotLeadbtn,
    manageProductLink,
    onHotLead,
  }) => {
    if (selectedTab === "7") {
      return (
        <div className="btn-sec">
          <div className="d-flex justify-content-center">
            <span
              style={{
                backgroundColor: isUpdateDisabled ? "lightgray" : "",
              }}
              onClick={() => {
                if (!isUpdateDisabled) onUpdate();
              }}
            >
              Update
            </span>
            <PostBuyLeadPopup
              empid={empid}
              ak={ak}
              glid={glid}
              descriptionValue={descHiddenValue}
              handleDisableBtn={handleDisableBtn}
            />
          </div>
        </div>
      );
    }

    return (
      <div className="btn-sec">
        <div className="d-flex justify-content-center">
          <span
            style={{
              backgroundColor: isUpdateDisabled ? "lightgray" : "",
            }}
            onClick={() => {
              if (!isUpdateDisabled) onUpdate();
            }}
          >
            Update
          </span>
          <span
            onClick={() => {
              const url = manageProductLink();
              if (url) {
                window.open(url, "_new");
                gaEvent(
                  "Seller gladmin redirection",
                  "Seller gladmin redirection",
                  "Seller gladmin redirection",
                  "Seller Redirection",
                  glid
                );
              }
            }}
          >
            Manage Product
          </span>
          {hotLeadbtn === 2 ? (
            <HotleadCreationForPaidSeller
              descHiddenValue={descHiddenValue}
              stsId={sts_id}
            />
          ) : (
            <span
              onClick={() => {
                onHotLead();
                gaEvent(
                  "Hot Lead New",
                  "Hot Lead when customer is interested in paid/ higher paid packages New",
                  "Hot Lead when customer is interested in paid/ higher paid packages New",
                  "Hot Lead when customer is interested in paid/ higher paid packages New",
                  glid
                );
              }}
            >
              Hot Lead
            </span>
          )}
        </div>
      </div>
    );
  }
);

// ─────────────────────────────────────────────────────────────────────────────
// UserDetails — wrapped in React.memo with a custom comparator that deliberately
// excludes selectedTab, so a tab switch never re-renders this whole component
// (and never re-fires its API calls). selectedTab flows only into TabEngagement
// and TabButtons which are cheap to re-render.
// ─────────────────────────────────────────────────────────────────────────────
const UserDetails = React.memo(
  ({
    selectedTab,
    descDispValue,
    glid,
    empid,
    ak,
    businessNature,
    groupCategoriesDisable,
    phtype,
    disableConnectSellerBtn,
    setDescId,
    setDescName,
    setDescClosureId,
    connectSellerStatus,
    selectedAccountRelatedTab,
  }) => {
    const employeeDetails = useContext(EmployeeContext);
    let emp_name = employeeDetails?.EMPLOYEENAME;
    let hotleadMessage = "";

    const [companyName, setCompanyName] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [add1, setAdd1] = useState("");
    const [add2, setAdd2] = useState("");
    const [designation, setDesignation] = useState("");
    const [cityId, setCityId] = useState("");
    const [countryIso, setCountryIso] = useState("");
    const [zipCode, setZipcode] = useState("");
    const [websiteURL, setwebsiteURL] = useState("Not Available");
    const [compDesc, setCompDesc] = useState("");
    const [stateID, setStateID] = useState("");
    const [email, setEmail] = useState("");
    const [phoneCountry, setPhoneCountry] = useState("");
    const [phoneArea, setPhoneArea] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [cityName, setCityName] = useState("");
    const [stateName, setStateName] = useState("");
    const [countryName, setCountryName] = useState("");
    const [pnsNo, setPnsNo] = useState("");
    const [isBlockedEmailDomain, setIsBlockedEmailDomain] = useState(false);
    const [businessType, setBusinessType] = useState("");
    const [gstNumber, setGstNumber] = useState("");
    const [updateGstNumber, setUpdateGstNumber] = useState("");
    const [glusr_Custtype, setGlusr_Custtype] = useState("");
    const [gstVerified, setGstVerified] = useState("");
    const [compId, setCompId] = useState();
    const [countriesData, setCountriesData] = useState([]);
    const [cityStateData, setCityStateData] = useState([]);
    const [oldFormData, setOldFormData] = useState({});
    const [name, setName] = useState("");
    const [gst_value_changes, setGst_value_changes] = useState(0);
    const [gstRadioBtn, setGstRadioBtn] = useState("");
    const [descriptionValue, setDescriptionValue] = useState("");
    const [cityStateValue, setCityStateValue] = useState("");
    const [businessTypeValue, setBusinessTypeValue] = useState("");
    const [showPopUpDiv, setShowPopUpDiv] = useState(false);
    const [htmlMsg, setHtmlMsg] = useState("");
    const [hotLeadbtn, setHotLeadBtn] = useState();
    const [updateEmail, setUpdateEmail] = useState(null);
    const [showIframe, setShowIframe] = useState(false);
    const [pinCodeValueChange, setPinCodeValueChange] = useState(0);
    const [phonicPopup, setPhonicPopUp] = useState(false);
    const targetRef = useRef(null);
    const wrapperRef = useRef(null);
    const [emailAutoSuggestionPopUp, setEmailAutoSuggestionPopUp] = useState(false);
    const [gstToopTip, setGSTToopTip] = useState("");
    const [nameToolTip, setNameToolTip] = useState("");
    const [mobileToolTip, setMobileToolTip] = useState("");
    const [topProductsCount, setTopProductsCount] = useState(0);
    const [topProductsList, setTopProductsList] = useState([]);
    const [readOnlyField, setReadOnlyField] = useState(false);
    const [organizationReadOnlyField, setOrganizationReadOnlyField] = useState(false);
    const [isUpdateDisabled, setIsUpdateDisabled] = useState(false);
    const [descHiddenValue, setDescHiddenValue] = useState("");
    const [appStat, setAppStat] = useState("");
    const [blackListEmailFlag, setBlackListEmailFlag] = useState(false);
    const [locationPref, setLocationPref] = useState(0);
    const [pincodeSelectionData, setPincodeSelectionData] = useState([]);

    const url = new URL(document.location.href);
    const params = url.searchParams;
    const crtObjectIdParam = params.get("crtObjectId");
    const dstPhone = params.get("dstPhone");
    const caller_Mobile = decryptPII(params.get("phone") ?? params.get("origNum"));

    const { paidFree, setGluserDisableReasons, parentGlid, setParentGlid, setGlusrData, did, stsId: sts_id, setStsId: setStsID } =
      useGlobalContext();
    const { setActiveServiceData, setPastServiceData } = useGlobalAppContext();
    const [remote_IP, setRemote_IP] = useState("");

    const fetchedGlid = useRef(null);
    const prevTabRef = useRef(null);

    const glusrDetails = async (glid) => {
      try {
        let glusrDetails_hash = await glusr_details(ak, glid);
        if (glusrDetails_hash.status === 200) {
          glusrDetails_hash = glusrDetails_hash.data;
          // glusr_usr_email/glusr_usr_ph_mobile (and _alt) arrive ciphertext from
          // /users/detail. Keep copies before they get overwritten with masked
          // values below — /sendSMS, /cmail, /user/update, /check-blacklist,
          // /whatsapp/communication_wrapper, /insertstsdata and /user/identify all
          // decrypt server-side, so passing them ciphertext keeps those flows free
          // of PII in the Network tab. The plaintext never reaches the browser at
          // all now — glusr_usr_email/glusr_usr_ph_mobile etc. below become MASKED
          // display strings (e.g. "pa***n@g***.com"), not real values.
          glusrDetails_hash["glusr_usr_ph_mobile_encrypted"] = glusrDetails_hash["glusr_usr_ph_mobile"];
          glusrDetails_hash["glusr_usr_ph_mobile_alt_encrypted"] = glusrDetails_hash["glusr_usr_ph_mobile_alt"];
          glusrDetails_hash["glusr_usr_email_encrypted"] = glusrDetails_hash["glusr_usr_email"];
          glusrDetails_hash["glusr_usr_email_alt_encrypted"] = glusrDetails_hash["glusr_usr_email_alt"];
          try {
            const maskedFields = await maskGlusrFields({
              glusr_usr_email: glusrDetails_hash["glusr_usr_email"],
              glusr_usr_email_alt: glusrDetails_hash["glusr_usr_email_alt"],
              glusr_usr_ph_number: glusrDetails_hash["glusr_usr_ph_number"],
              glusr_usr_ph_mobile: glusrDetails_hash["glusr_usr_ph_mobile"],
              glusr_usr_ph_mobile_alt: glusrDetails_hash["glusr_usr_ph_mobile_alt"],
              glusr_usr_im_gsm: glusrDetails_hash["glusr_usr_im_gsm"],
            });
            Object.assign(glusrDetails_hash, maskedFields.data);
            setIsBlockedEmailDomain(Boolean(maskedFields.data.isBlockedEmailDomain));
          } catch (maskError) {
            console.error("Failed to mask glusr PII fields:", maskError);
          }
          setGlusrData(glusrDetails_hash);
          setGluserDisableReasons(JSON.parse(glusrDetails_hash["glusr_disabled_reason"]) ?? "");
          setParentGlid(glusrDetails_hash["fk_parent_glusr_id"] ?? "");
          setCompanyName(glusrDetails_hash["glusr_usr_companyname"] ?? null);
          setAdd1(glusrDetails_hash["glusr_usr_add1"] ?? null);
          setAdd2(glusrDetails_hash["glusr_usr_add2"] ?? null);
          setDesignation(glusrDetails_hash["glusr_usr_designation"] ?? null);
          setCityId(glusrDetails_hash["fk_gl_city_id"] ?? 0);
          setCountryIso(glusrDetails_hash["fk_gl_country_iso"] ?? "");
          setZipcode(glusrDetails_hash["glusr_usr_zip"] ?? null);
          setCompDesc(glusrDetails_hash["glusr_usr_company_desc"] ?? null);
          setStateID(glusrDetails_hash["fk_gl_state_id"] ?? 0);
          setEmail(glusrDetails_hash["glusr_usr_email"] ?? null);
          setPhoneCountry(glusrDetails_hash["glusr_usr_ph_country"] ?? "");
          setPhoneArea(glusrDetails_hash["glusr_usr_ph_area"] ?? null);
          setPhoneNo(glusrDetails_hash["glusr_usr_ph_number"] ?? null);
          setMobileNo(glusrDetails_hash["glusr_usr_ph_mobile"] ?? "");
          setCityName(glusrDetails_hash["glusr_usr_city"] ?? null);
          setStateName(glusrDetails_hash["glusr_usr_state"] ?? null);
          setCountryName(glusrDetails_hash["country_name"] ?? "");
          setPnsNo(glusrDetails_hash["glusr_usr_im_gsm"] ?? null);
          setBusinessType(glusrDetails_hash["gl_primary_biz_type"] ?? null);
          setBusinessTypeValue(glusrDetails_hash["fk_glusr_usr_pbiz_id"] ?? 0);
          setGlusr_Custtype(glusrDetails_hash["glusr_usr_custtype_id"] ?? 0);
          setAppStat(glusrDetails_hash["glusr_usr_approv"]);
          setLocationPref(glusrDetails_hash["glusr_usr_loc_pref"]);
          setwebsiteURL(
            glusrDetails_hash["freeshowroom_url"] !== null
              ? glusrDetails_hash["freeshowroom_url"]
              : glusrDetails_hash["paidshowroom_url"] ?? null
          );
          setFirstName(glusrDetails_hash["glusr_usr_firstname"] ?? null);
          setLastName(glusrDetails_hash["glusr_usr_lastname"] ?? null);
          setOldFormData(glusrDetails_hash);
          setName(
            `${glusrDetails_hash["glusr_usr_firstname"] || ""} ${
              glusrDetails_hash["glusr_usr_lastname"] || ""
            }`
          );
          serviceDetais(glusrDetails_hash["glusr_usr_custtype_id"] ?? "");
          if (
            (glusrDetails_hash["glusr_usr_custtype_weight"] <= 1000 &&
              glusrDetails_hash["glusr_usr_custtype_weight"] !== 0) ||
            glusrDetails_hash["glusr_usr_custtype_weight"] === 1870
          ) {
            setReadOnlyField(true);
          }
          blackListEmail(
            glusrDetails_hash["glusr_usr_email_encrypted"] ?? "",
            glusrDetails_hash["glusr_usr_email_alt_encrypted"] ?? "",
            glusrDetails_hash["glusr_usr_ph_mobile_encrypted"] ?? "",
            glusrDetails_hash["glusr_usr_ph_mobile_alt_encrypted"] ?? ""
          );
        }
        const ip = await getIP();
        setRemote_IP(getCookie("CCIP") || ip.data?.ip);
      } catch (error) {
        console.error(error);
      }
    };

    useEffect(() => {
      if (
        document.location.pathname === "/api/html" ||
        document.location.pathname === "/Controllers/inBoundCenter.php"
      ) {
        if (glusr_Custtype !== "") {
          clickToCall(
            empid,
            ak,
            crtObjectIdParam,
            glid,
            caller_Mobile,
            dstPhone,
            glusr_Custtype,
            did,
            employeeDetails?.type
          );
        }
      }
    }, [glusr_Custtype]);

    const paidCustIds = [1, 2, 7, 10, 12, 13, 15, 31, 48];

    let salesempid = "";
    let salesexec = "";
    let teleexec = "";
    let teleempid = "";
    let acmgr = "";

    const serviceDetais = async (cust_id) => {
      try {
        const data = await getServiceDetailsCached(empid, ak, glid);
        if (data) {
          setActiveServiceData(data?.activeService);
          setPastServiceData(data?.pastService);
          if (data.assigneedetails.length > 0) {
            const assigneeDetails = data.assigneedetails[0];
            salesempid = assigneeDetails?.SALESEMPID ?? "";
            salesexec = assigneeDetails?.SALESEXEC ?? "";
            teleempid = assigneeDetails?.TELEEMPID ?? "";
            teleexec = assigneeDetails?.TELEEXEC ?? "";
          }
          if (teleempid !== "") {
            acmgr = teleexec;
          } else if (salesempid) {
            acmgr = salesexec;
          }
          if (paidCustIds.includes(cust_id)) {
            setHotLeadBtn(2);
          } else {
            setHotLeadBtn(1);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    const descCheck = async (value) => {
      if (crtObjectIdParam !== "") {
        if (glid !== "") {
          const cust_id_new = glusr_Custtype;
          const condition1 = `&descid=${value}&custid=${cust_id_new}`;
          const condition2 = `&glid=${glid}`;
          try {
            await insertclicktocall(empid, ak, crtObjectIdParam, "u", 1, condition1);
            await insertclicktocall(empid, ak, crtObjectIdParam, "u", 2, condition2);
          } catch (error) {
            console.log(error);
          }
          if (
            (glusr_Custtype === "" || glusr_Custtype === 0 || glusr_Custtype === null) &&
            value === "171"
          ) {
            await unblockSpamUser(
              empid,
              ak,
              glid,
              "block",
              `${crtObjectIdParam}~~Marked as Prank Call/Wrong Number 3rd time`,
              crtObjectIdParam
            );
          }
        }
      }
    };

    // Once per glid: fires on initial load and when customer changes
    useEffect(() => {
      if (glid && ak !== "" && fetchedGlid.current !== glid) {
        fetchedGlid.current = glid;
        prevTabRef.current = null; // reset so the auto-tab-set from wODetails is skipped below
        glusrDetails(glid);
        additionalUserDetails(glid);
        verifiedDetail(glid, ak);
      }
    }, [glid]);

    // On tab change: fires whenever user switches tabs (skips the initial auto-set)
    useEffect(() => {
      const prevTab = prevTabRef.current;
      prevTabRef.current = selectedTab;
      if (prevTab === null) return; // first run after glid init — skip
      if (prevTab !== selectedTab && glid && ak !== "") {
        glusrDetails(glid);
        additionalUserDetails(glid);
        verifiedDetail(glid, ak);
      }
    }, [selectedTab]);

    const countiresInfo = async (type) => {
    const CACHE_KEY = type === 1 ? "crm_countries_data" : "crm_citystate_data";
    const TTL_MS = 24 * 60 * 60 * 1000;

    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        const { data, ts } = JSON.parse(cached);
        if (Date.now() - ts < TTL_MS) {
          if (type === 1) setCountriesData(data);
          else setCityStateData(data);
          return;
        }
      } catch {}
    }

    if (!_countriesInfoPromise[type]) {
      // Use node proxy route via merpservices.countriesInfo (calls /api/countiresInfo)
      _countriesInfoPromise[type] = countriesInfo(empid, ak, type, "")
        .then(resp => resp.data)
        .then(result => {
          localStorage.setItem(CACHE_KEY, JSON.stringify({ data: result, ts: Date.now() }));
          _countriesInfoPromise[type] = null;
          return result;
        })
        .catch(err => {
          _countriesInfoPromise[type] = null;
          throw err;
        });
    }

    try {
      const result = await _countriesInfoPromise[type];
      if (type === 1) setCountriesData(result);
      else setCityStateData(result);
    } catch (error) {
      console.log(error);
    }
    };

    useEffect(() => {
      if (pinCodeValueChange === 1) {
        pincodeChange(empid, ak);
      }
    }, [pinCodeValueChange]);

    const pincodeChange = async (empid, ak, value) => {
      const condition = `&GL_LOCALITY_PINCODE=${value}`;
      try {
        const res = await countriesInfo(empid, ak, 3, condition);
        setPincodeSelectionData(res?.data);
        setCityId(parseInt(res?.data[0]?.GL_CITY_ID));
        setStateID(parseInt(res?.data[0]?.GL_STATE_ID));
        setStateName(res?.data[0]?.GL_STATE_NAME);
      } catch (error) {
        console.log(error);
      }
    };

    const formatDate = (dateString, status) => {
      if (!dateString) return "";
      const [datePart, timePart] = dateString.split(" ");
      const [day, month, year] = datePart.split("-");
      const [hour, minute] = timePart.split(":");
      const months = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
      const monthAbbreviation = months[parseInt(month, 10) - 1];
      const formattedDate = `${monthAbbreviation} ${parseInt(day, 10)} ${year} ${hour}:${minute}`;
      return `${status} on ${formattedDate}`;
    };

    const verifiedDetail = async (glid, ak) => {
      try {
        const res = await displayVerified(glid, ak);
        if (res?.data?.Response?.Code === "200") {
          const data = res?.data?.Response?.Data;
          const dateString2106 = data["2106"].User_verification_date;
          if (dateString2106) {
            setOrganizationReadOnlyField(true);
            setGSTToopTip(formatDate(dateString2106, data["2106"].Status));
            const dateString106 = data["106"].User_verification_date;
            if (dateString106) {
              setNameToolTip(formatDate(dateString106, data["106"].Status));
            }
            const dateString120 = data["120"].User_verification_date;
            if (dateString120) {
              setMobileToolTip(formatDate(dateString120, data["120"].Status));
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      countiresInfo(1);
      countiresInfo(2);
    }, []);

    const additionalUserDetails = async (glid) => {
      try {
        const response = await additionDetails(ak, glid);
        const res = response.data.Response;
        if (res.Code === "200") {
          const data = res.Data;
          setGstNumber(data?.GST ?? "");
          if (data?.GST) {
            setGstRadioBtn("Available");
          }
          setCompId(data?.GLUSR_USR_COMP_REG_ID ?? "");
          setGstVerified(data?.GST_VERIFIED ?? "");
        }
      } catch (error) {
        console.error(error);
      }
    };

    const updateUserDetails = (value, editData) => {
      if (value === 1) setName(editData);
      if (value === 2) setCompanyName(editData);
      if (value === 3) setAdd1(editData);
      if (value === 4) {
        setUpdateGstNumber(editData);
        if (editData !== "") setGst_value_changes(1);
      }
      if (value === 5) {
        setZipcode(editData);
        pincodeChange(empid, ak, editData);
      }
      if (value === 6) setMobileNo(editData);
      if (value === 7) {
        setUpdateEmail(editData.trim() === "" ? null : editData);
        if (editData.includes("@")) {
          setEmailAutoSuggestionPopUp(editData !== "");
        }
      }
      if (editData) setIsUpdateDisabled(false);
    };

    const validateGSTNumber = () => {
      const letterNumber = /^[0-9a-zA-Z]+$/;
      if (updateGstNumber !== "") {
        if (
          updateGstNumber.length < 15 ||
          updateGstNumber.length > 15 ||
          !updateGstNumber.match(letterNumber)
        ) {
          Alert("Invalid GST Number.");
          setIsUpdateDisabled(false);
          return false;
        } else {
          return GSTValidations(stateName, updateGstNumber);
        }
      }
    };

    const GSTValidations = (stateName, GSTvalue) => {
      const GSTsubstr = GSTvalue.substring(0, 2);
      const stateCodeMatch = GST_stateCode(GSTsubstr);
      if (stateCodeMatch) {
        if (stateCodeMatch.toLowerCase() !== stateName.toLowerCase()) {
          alert("GST does not match with state code. Kindly update your state.");
          return false;
        } else {
          return true;
        }
      } else {
        alert("GST does not match with state code. Kindly update your state.");
        return false;
      }
    };

    const GST_stateCode = (GSTvalue) => {
      const GST_stateId = {
        "01": "Jammu & Kashmir", "02": "Himachal Pradesh", "03": "Punjab",
        "04": "Chandigarh", "05": "Uttarakhand", "06": "Haryana", "07": "Delhi",
        "08": "Rajasthan", "09": "Uttar Pradesh", "10": "Bihar", "11": "Sikkim",
        "12": "Arunachal Pradesh", "13": "Nagaland", "14": "Manipur",
        "15": "Mizoram", "16": "Tripura", "17": "Meghalaya", "18": "Assam",
        "19": "West Bengal", "20": "Jharkhand", "21": "Odisha",
        "22": "Chhattisgarh", "23": "Madhya Pradesh", "24": "Gujarat",
        "25": "Daman & Diu", "26": "Dadra and Nagar Haveli", "27": "Maharashtra",
        "28": "Andhra Pradesh", "29": "Karnataka", "30": "Goa",
        "31": "Lakshadweep", "32": "Kerala", "33": "Tamil Nadu",
        "34": "Pondicherry", "35": "Andaman & Nicobar", "36": "Telangana",
        "37": "Andhra Pradesh", "38": "Ladakh",
      };
      return GST_stateId[GSTvalue];
    };

    const saveGSTNumber = () => {
      const validate_gst_num = validateGSTNumber();
      if (validate_gst_num === true) {
        actionGSTUpadate();
      } else {
        return false;
      }
    };

    const actionGSTUpadate = async (val) => {
      try {
        const result = await updateAdditionalDataGST(
          remote_IP, empid, ak, emp_name, glid,
          gstNumber !== "" ? gstNumber : updateGstNumber
        );
        if (result?.data?.MESSAGE === "Insert Success") {
          await insertComment(21);
          if (val !== 1) {
            setHtmlMsg("GST Updated.");
            setShowPopUpDiv(true);
          }
          setGst_value_changes(0);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const insertComment = async (actID) => {
      try {
        await ctcActivity(empid, ak, crtObjectIdParam, actID);
      } catch (error) {}
    };

    useEffect(() => {
      if (businessType !== "") {
        const intialValue = data.find((biz) => biz.value === businessTypeValue);
        setBusinessTypeValue(intialValue?.value ?? businessTypeValue);
      }
    }, [businessType]);

    // ── useCallback: prevents TabButtons from seeing a new function reference
    // on every render of UserDetails, which would defeat its memo.
    const handleUpdateGlusr = useCallback(
      async (val) => {
        if (descriptionValue === "") {
          Alert("Kindly fill the disposition first");
          return;
        }

        setDescHiddenValue("set");
        connectSellerStatus("set");
        setIsUpdateDisabled(true);

        let fullName = name.split(" ");

        const requestData = {
          AK: ak,
          FIRSTNAME: fullName[0],
          LASTNAME: fullName.slice(1).join(" "),
          COMPANYNAME: "",
          ADD1: "",
          FK_GL_COUNTRY_ISO: "IN",
          COUNTRYNAME: "India",
          ZIP: "",
          FK_GL_CITY_ID: "",
          CITY_OTHERS: "",
          FK_GL_STATE_ID: "",
          STATE_OTHERS: "",
          UPDATEDUSING: "Contact Center Process",
          UPDATEDBY: "",
          USR_ID: glid,
          IP: "",
          UPDATEDBY_ID: "",
          VALIDATION_KEY: "622fa9ce30b491b431d38a142ca572c8",
          MODID: "LEAPIN",
          EMAIL: "",
          PH_MOBILE: "",
          MODIFYSTATUS: "T",
          IP_COUNTRY: "India",
          LISTING_SOURCE: "TOLLFREE_IN",
        };

        requestData.FIRSTNAME = fullName[0] === "" ? null : fullName[0];
        requestData.LASTNAME = fullName.slice(1).join(" ") ?? null;
        requestData.COMPANYNAME = companyName;
        requestData.ADD1 = add1;
        requestData.FK_GL_COUNTRY_ISO = countryIso;
        requestData.COUNTRYNAME = countryName;
        requestData.ZIP = zipCode;
        requestData.FK_GL_CITY_ID = cityId;
        requestData.FK_GL_STATE_ID = stateID;
        requestData.UPDATEDBY = `${employeeDetails?.EMPLOYEENAME} ${empid}`;
        // EMAIL/PH_MOBILE go to /user/update, which now decrypts server-side (see
        // routes.js). When the agent hasn't actually edited these fields, submit the
        // ciphertext we preserved on load instead of the plaintext `email`/`mobileNo`
        // state, so a save that only touches e.g. company name never puts real PII on
        // the wire. `updateEmail`/`mobileNo` genuinely edited by the agent are real
        // freshly-typed text (not ciphertext), which the server-side decrypt already
        // passes through unchanged, so those are safe to send as-is.
        const mobileUnedited = mobileNo === oldFormData["glusr_usr_ph_mobile"];
        requestData.EMAIL = (oldFormData["glusr_usr_email_encrypted"]) ? oldFormData["glusr_usr_email_encrypted"] : updateEmail;
        requestData.USR_ID = glid;
        requestData.IP = remote_IP;
        requestData.UPDATEDBY_ID = empid;
        requestData.PH_MOBILE = mobileUnedited ? (oldFormData["glusr_usr_ph_mobile_encrypted"] || mobileNo) : mobileNo;
        if (!businessNature) {
          requestData.FK_PBIZ_ID = businessTypeValue;
        }

        if (glid) {
          if (
            oldFormData["glusr_usr_firstname"] === (fullName[0] !== "" ? fullName[0] : null) &&
            oldFormData["glusr_usr_lastname"] ===
              (fullName.slice(1).join(" ") === "" ? null : fullName.slice(1).join(" ")) &&
            oldFormData["glusr_usr_companyname"] === companyName &&
            oldFormData["glusr_usr_add1"] === add1 &&
            oldFormData["fk_gl_country_iso"] === countryIso &&
            oldFormData["glusr_usr_zip"] === zipCode &&
            oldFormData["fk_gl_city_id"] === cityId &&
            oldFormData["fk_gl_state_id"] === stateID &&
            oldFormData["glusr_usr_id"] === parseInt(glid) &&
            oldFormData["glusr_usr_email"] === (email ? email : updateEmail) &&
            oldFormData["glusr_usr_ph_mobile"] === mobileNo &&
            (!businessNature
              ? oldFormData["fk_glusr_usr_pbiz_id"] === (businessTypeValue === "" ? 0 : businessTypeValue)
              : true)
          ) {
            if (gst_value_changes === 1 && updateGstNumber !== "") {
              const abc = saveGSTNumber();
              if (abc === false) return false;
            } else {
              if (val !== 1) {
                setHtmlMsg("No details are updated.");
                setShowPopUpDiv(true);
              }
            }
          } else if (
            oldFormData["glusr_usr_firstname"] !== fullName[0] ||
            oldFormData["glusr_usr_lastname"] !== fullName[1] ||
            oldFormData["glusr_usr_companyname"] !== companyName ||
            oldFormData["glusr_usr_add1"] !== add1 ||
            oldFormData["fk_gl_country_iso"] !== countryIso ||
            oldFormData["glusr_usr_zip"] !== zipCode ||
            oldFormData["fk_gl_city_id"] !== cityId ||
            oldFormData["fk_gl_state_id"] !== stateID ||
            oldFormData["glusr_usr_id"] !== glid ||
            oldFormData["glusr_usr_email"] !== updateEmail ||
            oldFormData["glusr_usr_ph_mobile"] !== mobileNo ||
            (!businessNature
              ? oldFormData["fk_glusr_usr_pbiz_id"] === (businessTypeValue === "" ? 0 : businessTypeValue)
              : true)
          ) {
            try {
              gaEvent(
                "Update New",
                "Update User details for STS creation and existing user modifications New",
                "Update User details for STS creation and existing user modifications New",
                "Update User details for STS creation and existing user modifications New",
                glid
              );
              if (gst_value_changes === 1 && updateGstNumber !== "") {
                const validate_gst_num = validateGSTNumber();
                if (validate_gst_num === true) {
                  actionGSTUpadate(1);
                } else {
                  return false;
                }
              }
              lstStatusUpdation();
              // Validate whatever is actually being submitted as requestData.EMAIL
              // above — `email` is now a masked display string (e.g. "p***n@g***.com"),
              // not a real address, so it can't be format-validated; only real,
              // freshly-typed input (updateEmail, sent when there's no email on file
              // yet) needs checking.
              const emailToValidate = oldFormData["glusr_usr_email_encrypted"] ? "" : updateEmail?.trim();
              if (EmailValidation(emailToValidate)) {
                const res = await updateGlusrDetails(requestData);
                let dsr_comment = "Contact details modified";
                if (res?.data?.CODE === "200") {
                  if (res?.data?.MESSAGE === "Update Success") {
                    updateSTS(empid, ak, sts_id, empid, dsr_comment);
                    if (val !== 1) {
                      setHtmlMsg("User details have been updated");
                      setShowPopUpDiv(true);
                    }
                  }
                } else {
                  const errMessage = res?.data?.ERR_MSG?.REASON;
                  if (val !== 1) {
                    setHtmlMsg(`${errMessage}`);
                    setShowPopUpDiv(true);
                  }
                }
                await errorLogHandling(
                  "user/update",
                  requestData,
                  res?.data?.CODE === "200" ? res?.data?.MESSAGE : res?.data?.ERR_MSG?.REASON
                );
              } else {
                await errorLogHandling("user/update", requestData, "Email validation failing");
              }
            } catch (error) {
              console.log(error);
              await errorLogHandling("user/update", requestData, error.message);
            }
          } else if (gst_value_changes === 1) {
            const abc = saveGSTNumber();
            if (abc === false) return false;
          }

          const zip_code = zipCode;
          const city_id = cityId;
          let grp_selected = selectedTab;
          let prd_history = "";
          const dbh_mainr = true;
          if (sts_id === "") {
            let model = "";
            createNewSts(
              empid, model, caller_Mobile, mobileNo, emp_name,
              prd_history, city_id, zip_code, grp_selected, dbh_mainr, val
            );
          }
        } else {
          console.log("We have encountered an error. It will be resolved soon.");
        }
      },
      // Only re-create when these values actually change
      [
        descriptionValue, name, companyName, add1, countryIso, countryName,
        zipCode, cityId, stateID, email, updateEmail, mobileNo, businessNature,
        businessTypeValue, gst_value_changes, updateGstNumber, gstRadioBtn,
        gstNumber, oldFormData, sts_id, remote_IP, selectedTab,
        ak, empid, glid, employeeDetails,
      ]
    );

    // ── useCallback: same reason — stable reference for TabButtons
    const hot_leads = useCallback(async () => {
      if (gstRadioBtn === "exempted" || gstRadioBtn === "NotAvailable") {
        Alert("Hotlead Can Not be created as GST is not available");
        return false;
      } else if (descHiddenValue === "") {
        Alert("Please select the dispostion first");
        return false;
      } else if (gstNumber === "" && gstRadioBtn === "") {
        Alert("Hotlead Can Not be created. Please select if GST is available or not");
        return false;
      } else {
        const result = window.confirm(
          "Are you sure customer is interested in paid services ?"
        );
        if (result === true) {
          check_fields(1);
        }
      }

      let flag_gst = "";
      if (gstRadioBtn === "Available") flag_gst = "A";
      if (gstRadioBtn === "exempted") flag_gst = "E";
      if (gstRadioBtn === "NotAvailable") flag_gst = "N";

      try {
        await insertclicktocall(empid, ak, crtObjectIdParam, "u", 1, `&calltype=${flag_gst}`);
      } catch (error) {}
    }, [gstRadioBtn, descHiddenValue, gstNumber]);

    const createNewSts = async (
      empid, model = "", mobile = "", oNum = mobileNo, emp_name,
      prd_history, city_id, zip_code, grp_selected, dbh_mainr = true, hotleadbtnVal
    ) => {
      try {
        const stsID = await createSTS(empid, "");
        if (stsID) {
          let dsr_comment = "";
          let biz_type = "product";
          let tlead = "N";
          if (hotleadbtnVal === 1) {
            linkSTSWithGluser(
              stsID, glid, dsr_comment, biz_type, tlead, empid, model,
              mobile, oNum, crtObjectIdParam, emp_name, prd_history,
              city_id, zip_code, grp_selected, dbh_mainr, 1, ak, remote_IP
            );
            try {
              update_click_to_call_stsid(empid, ak, crtObjectIdParam, glid);
            } catch (error) {}
          }
        }
      } catch (error) {
        console.log(error);
      }
      return sts_id;
    };

    const lstStatusUpdation = async () => {
      try {
        await lstStatus_updation(glid, empid, ak, emp_name, remote_IP);
      } catch (error) {
        console.log(error);
      }
    };

    const linkSTSWithGluser = async (
      sts_id, glid, dsr_comment, biz_type, tlead, empid, model,
      mobile, oNum, crtObjectId, emp_name, prd_history, city_id,
      zip_code, grp_selected, dbh_mainr, new_sts, ak, remoteIP
    ) => {
      if (mobile === "") {
        console.log(`Getting Mobile number null while creating Sts for glid:${glid}`);
        return;
      }
      hotleadMessage = "";

      let ret_msg = "";
      let dsrComments = "";
      if (crtObjectId !== "") {
        lstStatusUpdation();
        if (mobile !== oNum) {
          // oNum (mobileNo) is already a masked display string — do not re-mask it.
          dsrComments += `${crtObjectId}~~Calling Number: ${oNum}.. Hot lead Created`;
        } else {
          dsrComments += `${crtObjectId}~~Received a call from ${maskMobileNumber(mobile)}.. Hot lead Created`;
        }
      } else {
        lstStatusUpdation();
        dsrComments += "Hot lead Created";
      }

      if (prd_history !== "") {
        dsr_comment = `${dsr_comment} \n\r ${prd_history}`;
      }

      if (dsrComments !== "") {
        const lead_type = "TF";
        dsr_comment = encodeURIComponent(dsrComments);
        const condition = `&glid=${glid}&data_type=${lead_type}&comments=${dsr_comment}&my_travel=${tlead}`;
        try {
          const resp = await hotlead_proc(empid, ak, condition);
          if (resp?.data?.data?.message) {
            ret_msg += resp?.data?.data?.message;
            const response = await HotLeadMessage(ret_msg, glid, empid, ak, parentGlid);
            hotleadMessage += response;
          } else {
            alert("Some Error Occurred Please Report, Hot Lead creation Error");
          }
        } catch (error) {
          console.log(error);
        }

        let sts_update_msg = "";
        if (mobile !== oNum) {
          // oNum (mobileNo) is already a masked display string — do not re-mask it.
          sts_update_msg += `Refernce to ${crtObjectId}~~Calling Number: ${oNum}.. : `;
        } else {
          sts_update_msg += `Refernce to ${crtObjectId}~~Received call from ${maskMobileNumber(mobile)}.. : `;
        }
        sts_update_msg += "eligible for live transfer to NSD tele team";

        if (hotleadMessage === "Hotlead Created Successfully!") {
          if (
            sessionStorage.getItem("new_sts_glid") &&
            sessionStorage.getItem("new_sts_glid") === glid
          ) {
            hotleadMessage +=
              "<br><br><b>Inform the customer that we will be transferring the call to sales team.</b><br><br>" +
              "<i>Please use the Blind Transfer option while transferring the call and disconnect the call from your phone after pressing the transfer button to initiate transfer.</i>";
            updateSTS(empid, ak, sts_id, empid, sts_update_msg);
          } else {
            let ispool = "N";
            let pool_id = "";
            let verticalId = "";
            try {
              await new Promise((resolve) => setTimeout(resolve, 1500));
              const res = await apiAssignToCompany(glid, 2);
              if (res?.data?.status === 200) {
                ispool = res?.data?.ISPOOL ?? "";
                pool_id = res?.data?.TELEASSIGNEDTO ?? "";
                verticalId = res?.data?.FK_IIL_VERTICAL_ID;
              }
            } catch (error) {
              console.log(error);
            }

            const poolArray = [83180, 102324];
            if (
              ispool === "Y" &&
              poolArray.includes(parseInt(pool_id))
            ) {
              hotleadMessage +=
                "<br><br><b>Inform the customer that we will be transferring the call to sales team.</b><br><br><i>Please use the Blind Transfer option while transferring the call and disconnect the call from your phone after pressing the transfer button to initiate transfer.</i>";
              updateSTS(empid, ak, sts_id, empid, sts_update_msg);
            }
          }
        } else {
          updateSTS(empid, ak, sts_id, empid, `Hotlead has been rejected due to : ${hotleadMessage}`);
        }
      } else if (dsr_comment !== "") {
        updateSTS(empid, ak, sts_id, empid, dsr_comment);
      }

      if (new_sts === 1) {
        let sales_assign = false;
        let numrows = 0;
        try {
          const res = await insertstsdata(empid, ak, zip_code, city_id);
          if (res?.data?.status === 200) {
            numrows = parseInt(res?.data?.data?.CNT);
          }
        } catch (error) {
          console.log(error);
        }
        if (numrows > 0) sales_assign = true;
        if (sales_assign) {
          hotleadMessage +=
            "<span>Inform the customer that we will be transferring the call to sales team for more details about IndiaMART Service and transfer the call to sales team using the Transfer button in CloudAgent.</span></b><br><br><i>Please use the Blind Transfer option while transferring the call and disconnect the call from your phone after pressing the transfer button to initiate transfer.</i>";
        }
      }
      setHtmlMsg(hotleadMessage);
      setShowPopUpDiv(true);
    };

    const createSTS = async (empid, form) => {
      const crtObjectId = crtObjectIdParam;
      try {
        let glusrDetails_hash = await glusr_details(ak, glid);
        if (glusrDetails_hash.status === 200) {
          glusrDetails_hash = glusrDetails_hash.data;
          let first_name = glusrDetails_hash["glusr_usr_firstname"] ?? "";
          let last_name = glusrDetails_hash["glusr_usr_lastname"] ?? "";
          let usr_add1 = glusrDetails_hash["glusr_usr_add1"] ?? "";
          let usr_add2 = glusrDetails_hash["glusr_usr_add2"] ?? "";
          let desig = glusrDetails_hash["glusr_usr_designation"] ?? "";
          let city_id = glusrDetails_hash["fk_gl_city_id"] ?? "";
          let con_iso = glusrDetails_hash["fk_gl_country_iso"] ?? "";
          let zip = glusrDetails_hash["glusr_usr_zip"] ?? "";
          let url = glusrDetails_hash["glusr_usr_url"] ?? "";
          let comp_desc = glusrDetails_hash["glusr_usr_company_desc"] ?? "";
          let state_id = glusrDetails_hash["fk_gl_state_id"] ?? "";
          let email = glusrDetails_hash["glusr_usr_email"] ?? "";
          let ph1_con = glusrDetails_hash["glusr_usr_ph_country"] ?? "";
          let ph1_area = glusrDetails_hash["glusr_usr_ph_area"] ?? "";
          let phone1 = glusrDetails_hash["glusr_usr_ph_number"] ?? "";
          let mobile1 = glusrDetails_hash["glusr_usr_ph_mobile"] ?? "";
          let city = glusrDetails_hash["glusr_usr_city"] ?? "";
          let state = glusrDetails_hash["glusr_usr_state"] ?? "";
          let country = glusrDetails_hash["country_name"] ?? "";
          let comp = glusrDetails_hash["glusr_usr_companyname"] ?? "";

          if (!comp) comp = companyName;
          if (!first_name) first_name = firstName ?? "";
          if (!last_name) last_name = lastName ?? "";
          if (!usr_add1) usr_add1 = add1 ?? "";
          if (!usr_add2) usr_add2 = add2 ?? "";
          if (!city_id) city_id = cityId ?? "";
          if (!state_id) state_id = stateID ?? "";
          if (!con_iso) con_iso = countryIso ?? "";
          if (!zip) zip = zipCode ?? "";
          if (!ph1_con) ph1_con = phoneCountry ?? "";
          if (!ph1_area) ph1_area = phoneArea ?? "";
          if (!phone1) phone1 = phoneNo ?? "";
          if (!mobile1) mobile1 = mobileNo ?? "";

          let phone;
          if (phone1 !== "" && ph1_con !== "" && ph1_area !== "") {
            phone = `+(${ph1_con})-(${ph1_area})-${phone1}`;
          }

          if (comp !== "" && glid !== "") {
            const assign_to = 33616;
            const masked = await maskGlusrFields({glusr_usr_ph_mobile: mobile1});
            let dsr_comment =
              crtObjectId !== ""
                ? `${crtObjectId}~~Received a call from ${masked.data.glusr_usr_ph_mobile ?? ''}.. Sts Created`
                : "Sts Created";
            const fullName = `${first_name} ${last_name}`;
            const ad = `${usr_add1} ${usr_add2}`;
            const inputArray = {
              ASSIGNEDTO: assign_to, TELEASSIGNEDTO: assign_to, PRIROTY: 4,
              COMPANY: comp, OPENINGCOMMENT: dsr_comment, OPENEDBY: empid,
              STATUS: 9, GENERALSTATUS: 1, TELESTATUS: 1, STS_PH_MOBILE: mobile1,
              SOURCE: "1", INTRESTED: 4, STS_FK_GLUSR_ID: glid,
              STS_COMPANY_UPDATEDBY: empid, STS_COMPANY_UPDATEDUSING: "Vendor CLI",
              STS_COMPANY_UPDATESCREEN: "Contact Center",
              STS_COMPANY_HIST_COMMENTS: dsr_comment, CONTACTPERSON: fullName,
              DESIGNATION: desig, ADDRESS: ad, CITY: city, COUNTRY: country,
              PIN: zip, PHONE: phone, URL: websiteURL,
              BUSINESSDESCRIPTION: comp_desc, STATE: state, EMAIL: email,
            };
            try {
              const resp = await createNewSTSID(empid, ak, JSON.stringify(inputArray));
              const sts = resp?.data?.data?.STSID;
              setStsID(sts);
              return sts;
            } catch (error) {
              console.log(error);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    const createbuyersts = async () => {
      if (glid !== "") {
        try {
          const res = await getSTSID(empid, ak, glid);
          if (res?.data?.status === 200) {
            setStsID(res?.data?.data?.STSID ?? "");
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (sts_id === "") {
        createNewSts(empid, "", caller_Mobile, mobileNo, emp_name, "", cityId, zipCode, selectedTab, true);
      }
    };

    useEffect(() => {
      const timerId = setTimeout(() => {
        if (countriesData.length !== 0) {
          const initialCityStateValue = cityStateData.find(
            (city) => city.GL_CITY_ID === cityId.toString()
          );
          if (initialCityStateValue) {
            setCityStateValue(
              `${initialCityStateValue.GL_CITY_ID}##${initialCityStateValue.GL_STATE_ID}`
            );
          }
        }
      }, 10000);
      return () => clearTimeout(timerId);
    }, [cityId, countriesData, cityStateData]);

    const check_fields = async (checkhotlead) => {
      if (descDispValue === 97 || descDispValue === 152 || descDispValue === 257) {
        createbuyersts();
      } else {
        if (name === "" || name === " ") {
          Alert("Kindly enter your fullName.");
          return false;
        } else if (name.length > 30) {
          Alert("First / Last name should not exceed 30 characters.");
          return false;
        }
        if (checkhotlead === 1 && (companyName === "" || companyName === null)) {
          Alert("Please provide the Company name.");
          return false;
        } else if (checkhotlead === 1 && !companyName.match(/\w/)) {
          Alert("Please provide the Company name.");
          return false;
        }

        let check_emailGlid = 0;
        if (check_emailGlid === 1 && email !== "") {
          Alert("This Email Id is already registered with IndiaMART. Enter a new ID to continue the registration.");
          return false;
        }
        if (email === "" || email === null) {
          if (checkhotlead === 1 && (updateEmail === null || updateEmail.trim() === "")) {
            Alert("Kindly enter your E-mail ID.");
            return false;
          }
        }
        if (updateEmail !== null) {
          let x = updateEmail.replace(/^\s+|\s+$/g, "");
          let atpos = x.indexOf("@");
          let dotpos = x.lastIndexOf(".");
          let space = x.indexOf(" ");
          let comma = x.indexOf(",");
          let hash1 = x.indexOf("#");
          let rbracket = x.indexOf(")");
          let lbracket = x.indexOf("(");
          let validarr = x.split("@");
          let sym_occr = 0;
          let email_test = updateEmail;
          if (email_test.match(/@/g)) {
            sym_occr = email_test.match(/@/g).length;
          }
          if (sym_occr > 1) {
            Alert("Invalid E-Mail ID! Kindly enter the correct E-mail ID.");
            return false;
          }
          if (
            x !== null &&
            x !== "" &&
            (atpos < 1 ||
              dotpos < atpos + 2 ||
              dotpos + 2 >= x.length ||
              space !== -1 ||
              comma !== -1 ||
              rbracket !== -1 ||
              lbracket !== -1 ||
              hash1 !== -1)
          ) {
            Alert("Invalid E-Mail ID! Kindly enter the correct E-mail ID.");
            return false;
          } else if (validarr[0].length === 0) {
            Alert("Invalid E-Mail ID! Kindly enter the correct E-mail ID.");
            return false;
          } else if (x.length > 100) {
            Alert("Email should not exceed 100 characters.");
            return false;
          } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(x)) {
            Alert("Invalid E-Mail ID! Kindly enter the correct E-mail ID.");
            return false;
          }
        }

        if (countryIso === "") {
          Alert("Please select a Country.");
          return false;
        }
        if (checkhotlead === 1 && (add1 === "" || add1 === null || add1.length < 10)) {
          Alert("Please enter Address (min. 10 char.)");
          return false;
        }
        if (countryIso === "IN") {
          if (checkhotlead === 1 && (zipCode === "" || zipCode === null)) {
            Alert("Please enter Pin Code.");
            return false;
          }
          if (zipCode !== "" && (isNaN(zipCode) || zipCode.length !== 6)) {
            Alert("Pin Code should be a 6 digit number.");
            return false;
          }
          if (cityId === 0 || stateID === 0) {
            Alert("Please select a State/City from drop down.");
            return false;
          }
        }
        if (checkhotlead === 1 && topProductsCount < 1) {
          Alert("Please enter atleast 1 product for Hotlead");
          return false;
        }
        if (businessNature === "") {
          if (checkhotlead === 1 && businessTypeValue === "") {
            Alert("Please select Business Type");
            return false;
          }
        }

        const check = await handleUpdateGlusr(1);
        if (check === false) return false;

        if (checkhotlead === 1) {
          let dsr_comment = "";
          let biz_type = "product";
          let tlead = "N";
          let model = "";
          let mobile = decryptPII(params.get("phone"));
          let oNum = mobileNo;
          let prd_history = "";

          if (sts_id === "") {
            if (glid !== "") {
              try {
                const res = await getSTSID(empid, ak, glid);
                if (res?.data?.status === 200) {
                  setStsID(res?.data?.data?.STSID ?? "");
                }
              } catch (error) {
                console.log(error);
              }
            }
          }
          linkSTSWithGluser(
            sts_id, glid, dsr_comment, biz_type, tlead, empid, model,
            mobile, oNum, crtObjectIdParam, emp_name, prd_history,
            cityId, zipCode, selectedTab, true, 0, ak, remote_IP
          );
          insertComment(2);
        }
      }
    };

    const handleDescriptionValue = (value, name, closureId) => {
      setDescriptionValue(value);
      setDescId(value);
      setDescName(name || "");
      setDescClosureId(closureId ?? "");
      descCheck(value);
      setHtmlMsg("Call Disposition has been updated.");
      setShowPopUpDiv(true);
      setTimeout(() => setShowPopUpDiv(false), 1000);
      setDescHiddenValue("set");
      connectSellerStatus("set");
      gaEvent(
        "Call Disposition",
        "Call Disposition has been updated",
        "Call Disposition has been updated",
        "Call Disposition has been updated",
        glid
      );
    };

    const handleCityStateValue = (value) => {
      if (value === "other") {
        setPincodeSelectionData([]);
        if (cityStateData.length > 0) {
          const firstCity = cityStateData[0];
          setCityStateValue(
            `${firstCity.GL_CITY_ID}##${firstCity.GL_STATE_ID}##${firstCity.GL_STATE_NAME}`
          );
          setCityId(parseInt(firstCity.GL_CITY_ID));
          setStateID(parseInt(firstCity.GL_STATE_ID));
          setStateName(firstCity.GL_STATE_NAME);
        }
      } else {
        setCityStateValue(value);
        setCityId(parseInt(value.split("##")[0]));
        setStateID(parseInt(value.split("##")[1]));
        setStateName(value.split("##")[2]);
      }
      setIsUpdateDisabled(false);
    };

    const handleCountryValue = (value) => {
      const countrydetails = value.split("#");
      setCountryIso(countrydetails[0]);
      setPhoneCountry(countrydetails[2] ?? value);
      setCountryName(countrydetails[3]);
      setIsUpdateDisabled(false);
    };

    const handleBusinessTypeValue = (value) => {
      setBusinessTypeValue(value);
      setIsUpdateDisabled(false);
    };

    const manageProductLink = useCallback(() => {
      return `https://seller.indiamart.com/login/adminlogin/emp_login/glusr_id/${glid}?redirectedurl=https://seller.indiamart.com/product/manageproducts`;
    }, [glid]);

    const handleClickConnectSeller = () => {
      if (descHiddenValue === "") {
        Alert("Kindly fill the disposition first");
        return false;
      }
      setShowIframe(true);
      if (targetRef.current) {
        targetRef.current.scrollIntoView({ behavior: "smooth" });
      }
    };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          setEmailAutoSuggestionPopUp(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const domains = ["gmail.com"];

    const handleSuggestionClick = (suggestion) => {
      setUpdateEmail(suggestion);
      setEmailAutoSuggestionPopUp(false);
    };

    const handleGstRadioBtn = (e) => {
      setGstRadioBtn(e.target.id);
      if (e.target.id !== "Available") {
        setUpdateGstNumber("");
        setGst_value_changes(0);
      }
    };

    const blackListEmail = async (email, email_alt, mobile, mobile_alt) => {
      // email/mobile here are ciphertext — /check-blacklist decrypts server-side
      // and derives the website (email domain) from the decrypted value itself,
      // since we can no longer split '@' out of an encrypted string client-side.
      const data = {
        email1: `${email}`, email2: `${email_alt}`,
        phone1: `${mobile}`, phone2: `${mobile_alt}`,
      };
      try {
        const res = await blackList(data);
        if (res?.data?.length > 0) setBlackListEmailFlag(true);
      } catch (error) {
        console.log(error);
      }
    };

    const handleDisableBtn = () => {
      if (glid) {
        if (appStat === "D" || appStat === "M") {
          disableConnectSellerBtn(true);
          return true;
        } else if (email) {
          // email is a masked display string now — the blocked-domain check runs
          // server-side (in /users/maskFields, against the real decrypted email)
          // and comes back as this boolean, so the real domain never has to reach
          // the browser just to answer this check.
          if (isBlockedEmailDomain) {
            disableConnectSellerBtn(true);
            return true;
          }
        } else {
          disableConnectSellerBtn(blackListEmailFlag);
          return blackListEmailFlag;
        }
        disableConnectSellerBtn(blackListEmailFlag);
        return blackListEmailFlag;
      }
    };

    const gstOptions = [
      { value: "Available", label: "Available" },
      { value: "NotAvailable", label: "Not Available" },
      { value: "exempted", label: "Exempted" },
    ];

    return (
      <>
        <DwhContextProvider>
          <div className="second-sec">
            <div className="d-flex align-items-start">
              {/* ── Column 1: Description + personal fields ── */}
              <div className="col-4 h-100 pe-3 border-right">
                <div className="first-box">
                  <div className="form-group has-float-label">
                    <DescriptionDropdown
                      handleDescriptionValue={handleDescriptionValue}
                      descDispValue={descDispValue}
                      paidFree={paidFree}
                      selectedAccountRelatedTab={selectedAccountRelatedTab}
                    />
                    <span>Description</span>
                  </div>
                  <input type="hidden" name="" id="descHidden" value={descHiddenValue} />
                  <div className="input-box">
                    <FloatLabelInput
                      value={name === " " ? "" : name}
                      handleInputChange={(e) => updateUserDetails(1, e.target.value)}
                      readOnlyField={readOnlyField}
                      spanName="Name"
                      verifiedCheckMark={nameToolTip}
                    />
                  </div>
                  <div className="input-box">
                    <FloatLabelInput
                      value={companyName}
                      handleInputChange={(e) => updateUserDetails(2, e.target.value)}
                      readOnlyField={readOnlyField || organizationReadOnlyField}
                      spanName="Company"
                    />
                  </div>
                  <div className="input-box">
                    {email ? (
                      <FloatLabelInput
                        className="disabled-input"
                        value={email}
                        readOnlyField={true}
                        spanName="E-mail"
                      />
                    ) : (
                      <FloatLabelInput
                        value={updateEmail}
                        handleInputChange={(e) => updateUserDetails(7, e.target.value)}
                        readOnlyField={readOnlyField}
                        spanName="E-mail"
                      />
                    )}
                    <span onClick={() => setPhonicPopUp(!phonicPopup)}>
                      <svg
                        className="speaking-icon cp"
                        xmlns="http://www.w3.org/2000/svg"
                        enableBackground="new 0 0 52 52"
                        viewBox="0 0 52 52"
                        id="speak"
                      >
                        <path fill="#DDD" d="M48.4317,28.86177c-0.28262,0.5971-6.70845,10.45878-5.43486,17.21832H26.63893l-1.14141-4.4979c-3.57753,0.8837-4.29968,0.84973-6.70448,0.47585c-2.4131-0.37388-2.22618-2.95704-1.99674-4.07869c0.22944-1.13015,0.20393-1.35955-0.62029-2.26876c-0.82442-0.90921,1.63992-4.15519-1.06216-4.91996c-0.19563-0.05098-1.07917-0.16145-1.24078-0.22939c-0.65431-0.23795-0.86674-1.05371-0.50121-1.63997l3.83229-5.67624c0.25475-0.42486,0.29728-0.94319,0.10186-1.39351l-0.3313-0.73081c-0.1531-0.33986-0.1699-0.71374-0.05954-1.06216c0,0,0.74268-2.38462,1.06216-3.15246c0.00363-0.00882,0.01328-0.02526,0.01701-0.03402c2.60229-6.20514,8.33589-10.95297,15.5756-10.95297c12.07693,0,19.97941,12.32552,14.87025,22.93418C48.4402,28.85326,48.4402,28.86177,48.4317,28.86177z"></path>
                        <path d="M48.43622,28.8501v0.0102c-0.29034,0.61211-6.69984,10.45117-5.44178,17.22204h-5.55379c-0.22422-1.15154-0.76429-6.21627,4.09655-14.95971c0.50953-0.71335,0.95791-1.46744,1.33496-2.26233c0.0102,0,0.0102-0.0102,0.0102-0.0102c0.99871-2.07885,1.55918-4.40232,1.55918-6.85822c0-7.93841-5.89016-14.53172-13.62475-15.83608C43.91542,3.89704,54.08101,17.21844,48.43622,28.8501z" opacity=".06"></path>
                        <path fill="#293C66" d="M43.0162 47.08028c-.00391.00049-.01172.00098-.01953 0H26.63925c-.45801 0-.85645-.31055-.96973-.75391l-.89844-3.5415c-1.66211.38525-2.62598.52197-3.56445.52197-1.94057 0-3.91451-.26756-4.85352-1.61963-.93164-1.33936-.68555-3.17969-.53613-3.90869.16211-.79688.16211-.79688-.38184-1.396-1.3913-1.53352 1.25043-4.33734-.96777-4.68994-.56152-.08887-.79199-.12988-.98047-.20898-1.17279-.42273-1.67534-1.9483-.96387-3.09131l3.85156-5.70703c.18145-.31045-.1663-.74782-.31055-1.15186-.25195-.55859-.28809-1.18945-.10156-1.77686.13209-.42709.92995-2.95409 1.14551-3.34717 2.95508-7.0581 9.27734-11.49023 16.46191-11.49023 12.86591 0 21.17598 13.14305 15.77148 24.36816l-.00098-.00049c-.31827.65329-6.42789 10.12323-5.39258 16.42725.04395.11328.06836.23682.06836.36621C44.0162 46.63253 43.56894 47.08028 43.0162 47.08028zM27.41757 45.08028h14.44238c-.41066-5.48058 2.8148-11.59214 5.70508-16.71582 4.72058-9.90228-2.64319-21.44531-13.99512-21.44531-6.36426 0-11.97949 3.96191-14.65332 10.33984-.34035.83778-.83586 2.42038-1.0459 3.09668-.02832.0874-.0459.21582.01563.354.07829.30729 1.06362 1.56981.1748 3.0498l-3.86035 5.72119c-.02539.04102-.00293.125.0127.14111.09473.02441.34277.06006.56641.09521 3.99184.63748 2.20544 4.23231 2.2168 5.41064.99512 1.12109 1.05859 1.67773.78027 3.05078-.15723.76758-.18262 1.79102.21777 2.3667.48555.7001 2.84932.76172 3.21191.76172.9248 0 1.94727-.17578 4.05078-.69531.53906-.13086 1.07422.19189 1.20996.72461L27.41757 45.08028zM4.97128 44.6506c-5.31738-6.78906-5.31738-16.27197 0-23.06152.34082-.43506.96973-.51172 1.40332-.17041.43555.34033.51172.96875.1709 1.40381-4.74805 6.06299-4.74805 14.53223 0 20.59473.34082.43506.26465 1.06348-.1709 1.40381C5.93765 45.16449 5.30879 45.08168 4.97128 44.6506z"></path>
                        <path fill="#293C66" d="M8.9498,40.58663c-3.08496-4.47217-3.0791-10.4707,0.0127-14.92578c0.31445-0.45361,0.93652-0.56738,1.3916-0.25098c0.45313,0.31445,0.56641,0.9375,0.25098,1.3916c-2.62012,3.7749-2.62402,8.8584-0.00879,12.64941c0.31348,0.45459,0.19922,1.07764-0.25586,1.39111C9.89155,41.15266,9.26667,41.04522,8.9498,40.58663z"></path>
                      </svg>
                    </span>
                  </div>
                  {emailAutoSuggestionPopUp && updateEmail.includes("@") && (
                    <div className="email-popup" ref={wrapperRef}>
                      {domains.map((domain) => {
                        const suggestion = updateEmail.includes("@")
                          ? updateEmail.split("@")[0]
                          : updateEmail;
                        return (
                          <div
                            key={domain}
                            className="email-option"
                            onClick={() => handleSuggestionClick(`${suggestion}@${domain}`)}
                          >
                            {`${suggestion}@${domain}`}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  <div className="input-box">
                    <FloatLabelInput
                      className={`${phoneCountry && mobileNo ? "disabled-input" : "form-control"}`}
                      value={`${
                        phoneCountry || mobileNo
                          ? `+${phoneCountry} - ${mobileNo}`
                          : ""
                      }`}
                      readOnlyField={true}
                      spanName="Contact No"
                      verifiedCheckMark={mobileToolTip}
                    />
                  </div>
                  <div className="input-box">
                    <label className="has-float-label">
                      <input
                        className="form-control cp"
                        style={{
                          color:
                            websiteURL === "Not Available" || websiteURL === null
                              ? "lightgrey"
                              : "blue",
                        }}
                        type="text"
                        placeholder=""
                        value={websiteURL !== "" ? websiteURL : "Not Available"}
                        onClick={() => {
                          if (websiteURL && websiteURL !== "Not Available") {
                            window.open(websiteURL);
                          }
                        }}
                        readOnly={websiteURL !== "Not Available" || websiteURL !== ""}
                      />
                      <span>Website</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* ── Column 2: Address + GST fields ── */}
              <div className="col-4 h-100 px-3 border-right">
                <div className="second-box h-100" style={{ marginTop: "-25px" }}>
                  <div className="input-box">
                    <FloatLabelInput
                      value={add1}
                      handleInputChange={(e) => updateUserDetails(3, e.target.value)}
                      readOnlyField={gstVerified === "Verified" || readOnlyField}
                      spanName="Address"
                    />
                  </div>
                  <div className="input-box">
                    <div className="form-group has-float-label">
                      <select
                        className="form-control"
                        id="city_state"
                        onChange={(e) => handleCityStateValue(e.target.value)}
                        disabled={gstVerified === "Verified" || readOnlyField}
                      >
                        <option value="" selected>--Select--</option>
                        {pincodeSelectionData.length > 0
                          ? pincodeSelectionData.map((city) => (
                              <option
                                key={city.GL_CITY_ID}
                                value={`${city.GL_CITY_ID}##${city.GL_STATE_ID}##${city.GL_STATE_NAME}`}
                                selected={city.GL_CITY_ID}
                              >
                                {city.GL_CITY_NAME + ", " + city.GL_STATE_NAME}
                              </option>
                            ))
                          : cityStateData.map((city) => (
                              <option
                                key={city.GL_CITY_ID}
                                value={`${city.GL_CITY_ID}##${city.GL_STATE_ID}##${city.GL_STATE_NAME}`}
                                selected={city.GL_CITY_ID === cityId.toString()}
                              >
                                {city.GL_CITY_NAME + ", " + city.GL_STATE_NAME}
                              </option>
                            ))}
                        {pincodeSelectionData.length <= 2 && (
                          <option value="other">Others</option>
                        )}
                      </select>
                      <span>City/State</span>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="col-6 pe-2">
                      <div className="input-box">
                        <FloatLabelInput
                          value={zipCode}
                          handleInputChange={(e) => {
                            updateUserDetails(5, e.target.value);
                            setPinCodeValueChange(1);
                          }}
                          readOnlyField={gstVerified === "Verified" ? true : false}
                          spanName="Pin Code"
                        />
                      </div>
                    </div>
                    <div className="col-6 ps-2">
                      <div className="input-box">
                        <div className="form-group has-float-label">
                          <select
                            className="form-control"
                            id="country"
                            onChange={(e) => handleCountryValue(e.target.value)}
                            disabled={gstVerified === "Verified" || readOnlyField}
                          >
                            <option selected value="91">--Select--</option>
                            {countriesData.map((countries) => {
                              const phoneCode = countries?.GL_COUNTRY_PHONECODE || "";
                              const countryName = countries?.GL_COUNTRY_NAME || "";
                              return (
                                <option
                                  key={countries.GL_COUNTRY_ISO}
                                  value={`${countries.GL_COUNTRY_ISO}##${phoneCode}#${countryName}`}
                                  selected={countries.GL_COUNTRY_ISO === countryIso}
                                >
                                  {countries.GL_COUNTRY_NAME}
                                </option>
                              );
                            })}
                          </select>
                          <span>Country</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="input-box">
                    {businessNature ? (
                      <label className="has-float-label">
                        <input
                          className="form-control"
                          type="text"
                          placeholder=""
                          value={businessNature}
                          readOnly
                        />
                        <span>Business Type</span>
                      </label>
                    ) : (
                      <label className="has-float-label">
                        <div className="form-group has-float-label">
                          <select
                            className="form-control"
                            id="businessType"
                            onChange={(e) => handleBusinessTypeValue(e.target.value)}
                          >
                            <option value="0" selected>---Select---</option>
                            {data.map((bizNames) => (
                              <option
                                key={bizNames.value}
                                value={bizNames.value}
                                selected={bizNames.bizName === businessType}
                              >
                                {bizNames.bizName}
                              </option>
                            ))}
                          </select>
                          <span>Business Type</span>
                        </div>
                      </label>
                    )}
                  </div>
                  <div className="input-box">
                    <label className="has-float-label">
                      {gstNumber !== "" ? (
                        <input
                          className="form-control disabled-input"
                          type="text"
                          readOnly
                          value={gstNumber}
                        />
                      ) : (
                        <input
                          className="form-control"
                          type="text"
                          placeholder=""
                          value={updateGstNumber}
                          onChange={(e) => updateUserDetails(4, e.target.value)}
                          disabled={gstRadioBtn !== "Available"}
                        />
                      )}
                      {gstVerified === "Verified" ? (
                        <svg
                          width="18" height="18" viewBox="0 0 18 18" fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-tooltip-id="my-tooltip"
                          data-tooltip-content={gstToopTip}
                          data-tooltip-place="top"
                        >
                          <path
                            d="M8.99739 17.3346C4.39502 17.3346 0.664062 13.6036 0.664062 9.0013C0.664062 4.39893 4.39502 0.667969 8.99739 0.667969C13.5997 0.667969 17.3307 4.39893 17.3307 9.0013C17.3307 13.6036 13.5997 17.3346 8.99739 17.3346ZM8.16623 12.3346L14.0588 6.44208L12.8803 5.26357L8.16623 9.97763L5.80924 7.62055L4.63072 8.79913L8.16623 12.3346Z"
                            fill="#008000"
                          />
                        </svg>
                      ) : null}
                      <Tooltip id="my-tooltip" />
                      <span>GST</span>
                    </label>
                  </div>
                  <div className={gstVerified !== "Verified" ? "radio-btn" : "radio-btn-mb"}>
                    {gstVerified !== "Verified" && (
                      <RadioButton
                        options={gstOptions}
                        selectedValue={gstRadioBtn}
                        handleGstRadioBtn={handleGstRadioBtn}
                        disabled={gstNumber !== ""}
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* ── Column 3: Engagement panel — ONLY this re-renders on tab change ── */}
              <TabEngagement
                selectedTab={selectedTab}
                glid={glid}
                empid={empid}
                ak={ak}
                companyName={companyName}
                setTopProductsList={setTopProductsList}
              />
            </div>
          </div>

          {/* Top Categories */}
          {(glid !== "" || selectedTab === "7") &&
            (selectedTab === "8" || selectedTab === "7") && (
              <TopCategories
                empid={empid}
                glid={glid}
                ak={ak}
                topProductsCount={setTopProductsCount}
                topProductsList={topProductsList}
                selectedTab={selectedTab}
              />
            )}

          {showPopUpDiv && (
            <Popup
              htmlMsg={htmlMsg}
              showPopUpDiv={showPopUpDiv}
              setShowPopUpDiv={setShowPopUpDiv}
            />
          )}

          {/* ── CTA buttons — ONLY this re-renders on tab change ── */}
          <TabButtons
            selectedTab={selectedTab}
            isUpdateDisabled={isUpdateDisabled}
            onUpdate={handleUpdateGlusr}
            glid={glid}
            empid={empid}
            ak={ak}
            descHiddenValue={descHiddenValue}
            handleDisableBtn={handleDisableBtn()}
            sts_id={sts_id}
            hotLeadbtn={hotLeadbtn}
            manageProductLink={manageProductLink}
            onHotLead={hot_leads}
          />

          {showIframe && (
            <div ref={targetRef}>
              <ConnectSeller glid={glid} mobileNo={mobileNo} />
            </div>
          )}
          {phonicPopup && (
            <PopupComponent phonicPopup={phonicPopup} setPhonicPopUp={setPhonicPopUp} />
          )}
          {glid && <EnterpriseSolutionsPopup glid={glid} />}
        </DwhContextProvider>
      </>
    );
  },
  // ── Custom comparator: return true = SKIP re-render.
  // selectedTab is deliberately excluded — tab changes should only affect
  // TabEngagement and TabButtons, never the whole UserDetails tree.
  (prevProps, nextProps) => {
    return (
      prevProps.glid === nextProps.glid &&
      prevProps.empid === nextProps.empid &&
      prevProps.ak === nextProps.ak &&
      prevProps.selectedTab === nextProps.selectedTab &&
      prevProps.descDispValue === nextProps.descDispValue &&
      prevProps.selectedAccountRelatedTab === nextProps.selectedAccountRelatedTab &&
      prevProps.businessNature === nextProps.businessNature &&
      prevProps.phtype === nextProps.phtype
    );
  }
);

export default UserDetails;